import { LandingPage } from './containers/landingPage';
import { SelectModelPage } from './containers/selectModelPage';
import { MainPage } from './containers/mainPage';
import {
  TechDocPage,
  TechDocChecklistPage,
  TechDocWizardPage,
} from './containers/pages';
import {
  UNBOX_VIDEO,
  CABLES_VIDEO,
  RACK_STEP1_VIDEO,
  RACK_STEP2_VIDEO,
  RACK_STEP3_VIDEO,
  POWER_VIDEO,
  ALLETRAMP_VIDEO_URL,
} from './constants';

export const LandingRoute = {
  path: '/',
  exact: true,
  component: LandingPage,
};

export const MainPageRoutes = [
  {
    path: '/main',
    component: MainPage,
  },
  {
    path: '/getting-started',
    exact: true,
    redirectTo: '/getting-started/select-model?model=',
  },
  {
    path: '/getting-started/select-model',
    exact: true,
    component: SelectModelPage,
  },
  {
    path: '/getting-started/cloud-enablement/',
    exact: true,
    redirectTo: '/getting-started/cloud-enablement/1',
    component: TechDocWizardPage,
    pageName: 'cloudenablement',
    prevPage: '/getting-started/select-model',
    nextPage: '/getting-started/checklist',
    pageProps: {
      steps: [
        {
          videoUrl: '',
          steptitle: 'Getting Started',
        },
        {
          videoUrl: '',
          steptitle: 'Create User Account',
        },
        {
          videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP3,
          steptitle: 'Create Workspace',
        },
        {
          videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP4,
          steptitle: 'Deploy Data Services Cloud Console',
        },
        {
          videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP5,
          steptitle: 'Assign Administrator',
        },
        {
          videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP6,
          steptitle: 'Add the Device to Your Workspace',
        },
      ],
    },
  },
  {
    path: '/getting-started/checklist',
    exact: true,
    component: TechDocChecklistPage,
    pageProps: {
      pageName: 'preInstallation',
      prevPage: '/getting-started/cloud-enablement',
      nextPage: '/physical-install',
    },
  },
  {
    path: '/physical-install',
    exact: true,
    redirectTo: '/physical-install/unbox',
  },
  {
    path: '/physical-install/unbox',
    exact: true,
    component: TechDocPage,
    pageProps: {
      pageName: 'unbox',
      videoUrl: UNBOX_VIDEO,
      prevPage: '/getting-started/checklist',
      nextPage: '/physical-install/rack/1',
    },
  },
  {
    path: '/physical-install/rack',
    exact: true,
    redirectTo: '/physical-install/rack/1',
  },
  {
    path: '/physical-install/rack/:step',
    exact: true,
    component: TechDocWizardPage,
    pageProps: {
      pageName: 'rack',
      prevPage: '/physical-install/unbox',
      nextPage: '/physical-install/cable',
      steps: [
        {
          videoUrl: RACK_STEP1_VIDEO,
        },
        {
          videoUrl: RACK_STEP2_VIDEO,
        },
        {
          videoUrl: RACK_STEP3_VIDEO,
        },
      ],
    },
  },
  {
    path: '/physical-install/cable',
    exact: true,
    component: TechDocPage,
    pageProps: {
      pageName: 'cable',
      videoUrl: CABLES_VIDEO,
      prevPage: '/physical-install/rack/3',
      nextPage: '/physical-install/powerOn',
    },
  },
  {
    path: '/physical-install/powerOn',
    exact: true,
    component: TechDocPage,
    pageProps: {
      pageName: 'powerOn',
      videoUrl: POWER_VIDEO,
      prevPage: '/physical-install/cable',
      nextPage: '/software-config',
    },
  },
  {
    path: '/software-config',
    exact: true,
    redirectTo: '/software-config/prepareClient',
  },
  {
    path: '/software-config/prepareClient',
    exact: true,
    component: TechDocPage,
    pageProps: {
      pageName: 'prepareClient',
      prevPage: '/physical-install/powerOn',
      nextPage: '/software-config/arrayDiscovery',
    },
  },
  {
    path: '/software-config/arrayDiscovery',
    exact: true,
    component: TechDocPage,
    pageProps: {
      pageName: 'arrayDiscovery',
      prevPage: '/software-config/prepareClient',
      nextPage: '/software-config/arraySetup',
    },
  },
  {
    path: '/software-config/arraySetup',
    exact: true,
    component: TechDocPage,
    pageProps: {
      pageName: 'arraySetup',
      prevPage: '/software-config/arrayDiscovery',
      nextPage: '/software-config/validation',
      contentType: 'react-showdown',
    },
  },
  {
    path: '/software-config/validation',
    exact: true,
    component: TechDocChecklistPage,
    pageProps: {
      pageName: 'arrayValidation',
      prevPage: '/software-config/arraySetup',
      nextPage: '/software-config/completeSetup',
    },
  },

  {
    path: '/software-config/completeSetup',
    exact: true,
    component: TechDocPage,
    pageProps: {
      pageName: 'setupComplete',
      prevPage: '/software-config/validation',
    },
  },
];
